import Component from './Component';
import { IGameState } from '../State/Game/IGameState';

export default class StateComponent extends Component {
    public handleStateChanged(state: IGameState): void {}
}
